import { sanitizeAuthUser } from './httpClient';

const KEY = 'ebi_user_profile';

export function saveUserProfile(user) {
    try {
        const safe = sanitizeAuthUser(user);
        sessionStorage.setItem(KEY, JSON.stringify(safe));
    } catch (e) {
        // ignore quota errors
    }
}

export function loadUserProfile() {
    try {
        const raw = sessionStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function clearUserProfile() {
    sessionStorage.removeItem(KEY);
}
